<template>
  <layout-center>
    <v-card class="mx-auto">
      <list-with-avatar
        :items="items"
        @toggleActive="
          ({ clickedItem }) => {
            $store.dispatch('dashboard/prep/TagsToggleActive', {
              item: clickedItem,
            });
          }
        "
        @update="
          ({ clickedItem }) => {
            $router.push({
              name: 'dashboard-prep-tags-create',
              params: { id: clickedItem.id },
            });
          }
        "
        @clicked="
          ({ clickedItem }) => {
            $router.push({
              name: 'dashboard-prep-tags-questions',
              params: { id: clickedItem.id },
            });
          }
        "
      />
      <fab-button
        :icon="'mdi-plus'"
        color="primary"
        @clicked="$router.push({ name: 'dashboard-prep-tags-create' })"
      />
    </v-card>
  </layout-center>
</template>

<script>
import { mapGetters } from "vuex";
import FabButton from "@/components/FabButton.vue";
import ListWithAvatar from "../../modules/ListWithAvatar.vue";
import LayoutCenter from "@/layouts/LayoutCenter.vue";

export default {
  name: "dashboard-prep-tags",
  components: {
    FabButton,
    ListWithAvatar,
    LayoutCenter,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
  },
  watch: {},
  methods: {},
  created() {
    this.$store.dispatch("dashboard/prep/TagsGetAll", { context: this });
  },
};
</script>
